import { useMemo } from "react";
import { AvisForm, IAvisFormProps } from "../../../shared/components";
import { EventReportInfo } from "../../../../generated/data-contracts";
import { TimeUtils } from "../../../../utils";

interface ILicenseReportFormProps extends IAvisFormProps {
  data: EventReportInfo;
}
export function LicenseReportForm(props: Readonly<ILicenseReportFormProps>) {
  const { data, pageTitle, children, loading, ...restProps } = props;

  const pageTitleValue = useMemo(() => {
    if (loading) return;

    if (pageTitle) return pageTitle;

    return `${data.licenseNumber}: ${TimeUtils.formatPeriod(
      data.periodFrom,
      data.periodTo,
    )}`;
  }, [data, loading, pageTitle]);
  return (
    <AvisForm pageTitle={pageTitleValue} {...restProps}>
      {children}
    </AvisForm>
  );
}
